import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  CART_LAYOUTS_REQUESTED,
  CART_LAYOUTS_SUCCESS,
  CART_LAYOUTS_FAILURE,
  CART_LAYOUT_FIND_REQUESTED,
  CART_LAYOUT_FIND_SUCCESS,
  CART_LAYOUT_FIND_FAILURE,
  CART_LAYOUT_CREATE_REQUESTED,
  CART_LAYOUT_CREATE_SUCCESS,
  CART_LAYOUT_CREATE_FAILURE,
  CART_LAYOUT_UPDATE_REQUESTED,
  CART_LAYOUT_UPDATE_SUCCESS,
  CART_LAYOUT_UPDATE_FAILURE,
  CART_LAYOUT_DELETE_REQUESTED,
  CART_LAYOUT_DELETE_SUCCESS,
  CART_LAYOUT_DELETE_FAILURE,
} from '../types';

export const cartLayoutsRequested = () => {
  return {
    type: CART_LAYOUTS_REQUESTED
  }
};

export const cartLayoutsSuccess = (cartLayouts) => {
  return {
    type: CART_LAYOUTS_SUCCESS,
    payload: cartLayouts
  }
};

export const cartLayoutsFailure = () => {
  return {
    type: CART_LAYOUTS_FAILURE
  }
};

export const cartLayoutFindRequested = () => {
  return {
    type: CART_LAYOUT_FIND_REQUESTED
  }
};

export const cartLayoutFindSuccess = (cartLayout) => {
  return {
    type: CART_LAYOUT_FIND_SUCCESS,
    payload: cartLayout
  }
};

export const cartLayoutFindFailure = () => {
  return {
    type: CART_LAYOUT_FIND_FAILURE
  }
};

export const cartLayoutCreateRequested = () => {
  return {
    type: CART_LAYOUT_CREATE_REQUESTED
  }
};

export const cartLayoutCreateSuccess = (cartLayout) => {
  return {
    type: CART_LAYOUT_CREATE_SUCCESS,
    payload: cartLayout
  }
};

export const cartLayoutCreateFailure = () => {
  return {
    type: CART_LAYOUT_CREATE_FAILURE
  }
};



export const cartLayoutUpdateRequested = () => {
  return {
    type: CART_LAYOUT_UPDATE_REQUESTED
  }
};

export const cartLayoutUpdateSuccess = (cartLayout) => {
  return {
    type: CART_LAYOUT_UPDATE_SUCCESS,
    payload: cartLayout
  }
};

export const cartLayoutUpdateFailure = () => {
  return {
    type: CART_LAYOUT_UPDATE_FAILURE
  }
};


export const cartLayoutDisableRequested = (cartLayoutId) => {
  return {
    type: CART_LAYOUT_DELETE_REQUESTED,
    cartLayoutId: cartLayoutId
  }
};

export const cartLayoutDisableSuccess = () => {
  return {
    type: CART_LAYOUT_DELETE_SUCCESS
  }
};

export const cartLayoutDisableFailure = () => {
  return {
    type: CART_LAYOUT_DELETE_FAILURE
  }
};



export const cartLayoutsIndex = (signedPayload) => {
  return (dispatch) => {
    dispatch(cartLayoutsRequested());

    let endPoint = Config.baseUrl + Config.cartLayouts;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(cartLayoutsSuccess(response.data));
      })
  }
}

export const cartLayoutFind = (signedPayload, cartLayoutId) => {
  return (dispatch) => {
    dispatch(cartLayoutFindRequested());

    let endPoint = Config.baseUrl + Config.cartLayout + cartLayoutId;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(cartLayoutFindSuccess(response.data));
      })
      .catch((error) => {
        dispatch(cartLayoutFindFailure());
      });

  }
}

export const cartLayoutCreate = (signedPayload, label, rows, columns, toteLabels) => {
  return (dispatch) => {
    dispatch(cartLayoutCreateRequested());

    let endPoint = Config.baseUrl + Config.cartLayout;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.post(endPoint, { label: label, rows: rows, columns: columns, toteLabels: toteLabels }, { headers: headers })
      .then((response) => {
        dispatch(cartLayoutCreateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(cartLayoutCreateFailure());
      });

  }
}

export const cartLayoutUpdate = (signedPayload, id, label, rows, columns, toteLabels) => {
  return (dispatch) => {
    dispatch(cartLayoutUpdateRequested());

    console.log(id);

    let endPoint = Config.baseUrl + Config.cartLayout;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.put(endPoint, { id: id, label: label, rows: rows, columns: columns, toteLabels: toteLabels }, { headers: headers })
      .then((response) => {
        dispatch(cartLayoutUpdateSuccess(response.data));
      })

  }
}

export const cartLayoutDisable = (signedPayload, id) => {
  return (dispatch) => {
    dispatch(cartLayoutDisableRequested(id));

    let endPoint = Config.baseUrl + Config.cartLayout + id;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.delete(endPoint, { headers: headers })
      .then((response) => {
        dispatch(cartLayoutDisableSuccess(response.data));
      })
      .catch((error) => {
        dispatch(cartLayoutDisableFailure());
      });
  }
}
